export default "__VITE_ASSET__C9z2P3om__"